import { Injectable,Component,NgZone, OnInit,ViewChild, PLATFORM_ID, Inject, Input, Output, EventEmitter, OnChanges, ElementRef,HostListener } from '@angular/core';
import { FormBuilder,FormGroup,FormControl,Validators,NgForm } from '@angular/forms';
import { commonService } from '../../service/common.service';
import { pgService } from '../../service/pg.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import {ActivatedRoute} from "@angular/router";
import {Globals } from '../../globals';
import {NgbCarouselConfig,NgbModal,NgbModalRef,ModalDismissReasons, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import { DxRangeSliderModule, DxNumberBoxModule } from 'devextreme-angular';
import { BrowserModule } from '@angular/platform-browser';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { GooglePlaceDirective } from "ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive";
import { ComponentRestrictions } from "ngx-google-places-autocomplete/objects/options/componentRestrictions";
import { Address } from "ngx-google-places-autocomplete/objects/address";
import { AutoCompleteSearchService } from 'ng4-geoautocomplete/auto-complete.service';
import { GlobalRef } from 'ng4-geoautocomplete/windowRef.service';
import { AgmCoreModule, MapsAPILoader,GoogleMapsAPIWrapper } from '@agm/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';

import {} from '@types/googlemaps';
import { MouseEvent } from '@agm/core';
import { ViewEncapsulation } from '@angular/core'

//import { google,maps } from '@google/maps';
//import { google } from '@agm/core/services/google-maps-types'


declare var google:any;
declare var jQuery:any;

export interface Settings {
  geoPredictionServerUrl?: string;
  geoLatLangServiceUrl?: string;
  geoLocDetailServerUrl?: string;
  geoCountryRestriction?: any;
  geoTypes?: any;
  geoLocation?: any;
  geoRadius?: number;
  serverResponseListHierarchy?: any;
  serverResponseatLangHierarchy?: any;
  serverResponseDetailHierarchy?: any;
  resOnSearchButtonClickOnly?: boolean;
  useGoogleGeoApi?: boolean;
  inputPlaceholderText?: string;
  inputString?: string;
  showSearchButton?: boolean;
  showRecentSearch?: boolean;
  showCurrentLocation?: boolean;
  recentStorageName?: string;
  noOfRecentSearchSave?: number;
  currentLocIconUrl?: string;
  searchIconUrl?: string;
  locationIconUrl?: string;
}

@Component({
  selector: 'app-vpg',
  templateUrl: './vpg.component.html',
  styleUrls: ['./vpg.component.css',
  '../../../../src/assets/scss/dx.common.css', 
  '../../../../src/assets/scss/dx.contrast.css'],
  encapsulation: ViewEncapsulation.None,
  providers:[Globals,pgService,NgbCarouselConfig,GoogleMapsAPIWrapper],
  host: {
    '(document:click)': 'closeAutocomplete($event)',
   }
})

export class VpgComponent implements OnInit {
  /* @param prop - Property of each object to compare*/
  @Input() public options; // for bookmarks
  formoption:any={createpost:true};
  
  @Input() userSettings: Settings;
  @Output()
componentCallback: EventEmitter<any> = new EventEmitter<any>();

public locationInput: string = '';
public lat: string = '';
public lng: string = '';
public latitude: number;
public longitude: number;
public zoom: number=14;
public searchControl: FormControl;
@ViewChild("search")
public searchElementRef: ElementRef;
public gettingCurrentLocationFlag: boolean = false;
public dropdownOpen: boolean = false;
public recentDropdownOpen: boolean  = false;
public queryItems: any = [];
public isSettingsError: boolean = false;
public settingsErrorMsg: string = '';
public settings: Settings = {};
private moduleinit: boolean = false;
private selectedDataIndex: number = -1;
private recentSearchData: any = [];
private userSelectedOption: any = '';
private defaultSettings: Settings = {
  geoPredictionServerUrl: '',
  geoLatLangServiceUrl: '',
  geoLocDetailServerUrl: '',
  geoCountryRestriction: [],
  geoTypes: [],
  geoLocation: [],
  geoRadius: 0,
  serverResponseListHierarchy: [],
  serverResponseatLangHierarchy: [],
  serverResponseDetailHierarchy: [],
  resOnSearchButtonClickOnly: false,
  useGoogleGeoApi: true,
  inputPlaceholderText: 'Enter Area Name',
  inputString: '',
  showSearchButton: true,
  showRecentSearch: true,
  showCurrentLocation: true,
  recentStorageName: 'recentSearches',
  noOfRecentSearchSave: 5,
  currentLocIconUrl: '',
  searchIconUrl: '',
  locationIconUrl: ''
};

  user:any;
  isError=false;
  pgshowgallery=false;
  msg:any;
  hostelruleslist:any;
  isSuccess=false;
  totalrow:number;
  searchtxt:string;
  notfound=false;
  pgdetails:any=[];
  filterdetail=[];
  //sortedData;
  pageSize = 10;
  currentPage = 0;
  totalSize = 0;
  start=0;
  end=10;
  closeResult: string;
  searchpgFrom: FormGroup;
  //citylist=[{'id':'57337','value':'Mumbai'},{'id':'56919','value':'Bangalore'},{'id':'301','value':'Pune'},{'id':'57733','value':'Chennai'},{'id':'56719','value':'Gurgaon'},{'id':'56550','value':'Delhi'},{'id':'58735','value':'Noida'}];
  citylist=[{'id':'56550','value':'Delhi'}]
  BHKDroplist=[{'id':'1','value':'1RK'},{'id':'2','value':'1BHK'},{'id':'3','value':'2BHK'},{'id':'4','value':'3BHK'},{'id':'5','value':'4BHK'},{'id':'6','value':'4+BHK'}];

  label: any;
  tooltip: any;
  tooltipEnabled: any;
  filterarryinfo:any;
  formvailidation=false;
  recordmsg:any;
  filtrcity:any;
  filterbhk:any;
  formBHKK:any;
  filtersrtprice=0;
  filterendprice=50000;
  filtersrtdistance=0;
  filterenddistance=15;
  amenitiesbox:any;
  pgamenitiesArry: Array<any> = [];
  pgBhkArry: Array<any> = [];
  showfilterAvailBhk=true;
  filterbkhstring='';
  filteramenitiesArry: Array<any> = [];
  showcitydata:any;
  latt: Number = 24.799448;
  lngg: Number = 120.979021;
  limit=20;
  totalcountdata:any;
  ownerForm: FormGroup;
  //google maps zoom

  contentlist=[];
  isPostLoad=true;
  isRemaningForum=true;
  noMoreResults=false;
  showfilterContaint=false;
  showfiltercssfirst=true;
  showsearchcontaint=true;
  userData:any;
  dataarryfavrt:any;

  modalReference:NgbModalRef;
  msgpopup="";
  pageoffset=0;
  favloaddata='';
  verifyOtpId:any;
  verifyStatus=false;
  mobilevailidation=false;
  ownerarry:any;
  pgownerveifymsg:any;
  msgclass:any="";

  isFavourite = false;
  fvrUserId = 0;
  PG={'title':'PG','desciprtion':'desciprtion'};

//Get Directions
  dir = undefined;
  public getDirection() {
    this.dir = {
      origin: { lat: 24.799448, lng: 120.979021 },
      destination: { lat: 24.799524, lng: 120.975017 }
    }
  }

  constructor(private modalService: NgbModal,config: NgbCarouselConfig,private router:Router,private route: ActivatedRoute,private commonservice:commonService,private global: Globals,private _pg:pgService,private frmBuilder: FormBuilder,@Inject(PLATFORM_ID) private platformId: Object,
  private _elmRef: ElementRef, private _global: GlobalRef,
  private _autoCompleteSearchService: AutoCompleteSearchService,private mapsAPILoader: MapsAPILoader,
  private ngZone: NgZone,configg: NgbCarouselConfig,private gmapsApi: GoogleMapsAPIWrapper) {
      //this.user=commonservice.user;
      config.interval = 10000;
      config.wrap = false;
      config.keyboard = false;
      this.label = {
        visible: true,
        format: (value) => {
            return this.format(value);
        },
        position: "top"
    };
    this.tooltip = {
        enabled: true,
        format: (value) => {
            return this.format(value);
        },
        showMode: "always", 
        position: "top"
    };
    this.tooltipEnabled = {
        enabled: true
    };
    this.filterarryinfo={
      city:'',
      BHK:''
    }
    this.showcitydata={
      cityname:'City',
      bhk:'BHK',
    }
    this.ownerarry={
      'studmobile':'',
      'otp':'',
    }

    this.commonservice.profile.subscribe((data:any)=>{
     
      if(data){
      this.userData=data; 
      //console.log(this.userData.length);
      }else{
        this.userData={};
      } 
      
    });

   }
   path=this.global.pgUrl;


  

ngOnInit() {

	 if(!this.options){
	  this.formoption={}
	 }else{
	  this.formoption=this.options;
   }

   if(this.formoption.bookmarkType=='pg'){
    this.isFavourite=true;   
    this.fvrUserId=this.userData.id;   
  }
	
  this.getpgamenities();
    if (!this.moduleinit) {
      this.moduleInit();
      }
      this.recordmsg='Data not found.';
      let locarry:any;

      locarry={BHK:this.filterbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:this.filtersrtdistance,distance:this.filterenddistance,startprice:this.filtersrtprice,endprice:this.filterendprice,isFavourite:this.isFavourite,fvrUserId:this.fvrUserId}
      this.getfilterData(locarry);
      
}

@HostListener('window:scroll', ['$event'])
checkScroll() {
   var scrollPosition = $(window).scrollTop() + $(window).height();
   var pageheight =  $(document).height()-$('#footer-section').outerHeight();
   //console.log('load');
   //console.log(this.isRemaningForum);
   //var pageheight =  $(document).height()-100;
   if(scrollPosition >= pageheight && this.isRemaningForum==true && this.contentlist.length>0) {
     this.isPostLoad=true;
     let locarry:any;
     locarry={BHK:this.filterbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:this.filtersrtdistance,distance:this.filterenddistance,startprice:this.filtersrtprice,endprice:this.filterendprice,isFavourite:this.isFavourite,fvrUserId:this.fvrUserId}
     this.getfilterData(locarry);

   }
}

format(value){
    return value + "";
   }
onValueChanged(e) {
  this.clearContenlist();
  this.isRemaningForum=true;
  let pgfilterdetails: any[] = [];
      if(this.filtrcity!=undefined){
        this.filtersrtprice=e.value[0];
        this.filterendprice=e.value[1];
        let locarry:any;
        locarry={BHK:this.filterbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:this.filtersrtdistance,distance:this.filterenddistance,startprice:this.filtersrtprice,endprice:this.filterendprice}
        this.getfilterData(locarry);
    }
}
onlocChang(e){
  this.clearContenlist();
  this.isRemaningForum=true;
  let locarry:any;
  if(this.filtrcity!=undefined){
    this.filtersrtdistance=e.value[0];
    this.filterenddistance=e.value[1];
    locarry={BHK:this.filterbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:e.value[0],distance:e.value[1],startprice:this.filtersrtprice,endprice:this.filterendprice}
    this.getfilterData(locarry);
  }
}

onamenityChange(ruleID:number, isChecked: boolean) {
  this.clearContenlist();
  this.isRemaningForum=true;
  if(isChecked) {
    this.pgamenitiesArry.push(ruleID);
    // let element = document.getElementById('ruleID');
    // element.className = 'active';
  } else {
    let index = this.pgamenitiesArry.indexOf(ruleID);
    this.pgamenitiesArry.splice(index,1);
  }
  //console.log(this.pgamenitiesArry);
  this.filteramenitiesArry=this.pgamenitiesArry;
 if(this.filtrcity!=undefined){
    let locarry:any;
    locarry={BHK:this.filterbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:this.filtersrtdistance,distance:this.filterenddistance,startprice:this.filtersrtprice,endprice:this.filterendprice}
    this.getfilterData(locarry);
  }
}
onBhkChange(ruleID:number, isChecked: boolean) {
  this.clearContenlist();
  this.isRemaningForum=true;
  if(isChecked) {
    this.pgBhkArry.push(ruleID);
    // let element = document.getElementById('ruleID');
    // element.className = 'active';
  } else {
    let index = this.pgBhkArry.indexOf(ruleID);
    this.pgBhkArry.splice(index,1);
  }
  var newbkhstring='';
  var y=1;
  for(var i in this.pgBhkArry){
    if(y==this.pgBhkArry.length){
      newbkhstring+="'"+this.pgBhkArry[i]+"'";
    }else{
      newbkhstring+="'"+this.pgBhkArry[i]+"',";
    }
    y++;
  }
  //console.log(newbkhstring);
  this.filterbkhstring=newbkhstring;
  if(this.filtrcity!=undefined){
    let locarry:any;
    locarry={BHK:newbkhstring,amenityArry:this.filteramenitiesArry,BHKK:this.formBHKK,city:this.filtrcity,lat:this.lat,lng:this.lng,distancestart:this.filtersrtdistance,distance:this.filterenddistance,startprice:this.filtersrtprice,endprice:this.filterendprice}
    this.getfilterData(locarry);
  }
}

getpgamenities(){
  this._pg.pgamenities('').subscribe((data : any)=>{
          if(data.error==0){ 
            //console.log(data.results);
            this.amenitiesbox = data.results;   
          }else{
            if(data.message=="Failed to authenticate token."){
              this.router.navigate(['/admin']);
            }else{
             this.msg = data.message;
             this.isError = true;
            }
          }
   },
     (error : HttpErrorResponse)=>{
       this.isError = true;
       this.msg="internal server error!";
     });

}
  
open2(content) { 
  this.verifyOtpId='';
        this.verifyStatus=false;
        // this.mobilevailidation=true;
        // this.msgclass="success";
        this.ownerarry={
          'studmobile':'',
          'otp':'',
        }
  this.modalService.open(content).result.then((result) => {
    this.closeResult = `Closed with: ${result}`;
  },(reason) => {
    this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
  }
  );
}
private getDismissReason(reason: any): string {
  if (reason === ModalDismissReasons.ESC) {
    return 'by pressing ESC';
  } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
    return 'by clicking on a backdrop';
  } else {
    return  `with: ${reason}`;
  }
}
searchfilter(form){
  if(form.status=="INVALID"){
    //console.log('not valid');
    this.formvailidation=true;
   }else{
  this.clearContenlist();
  //console.log('jhvbfdfghddf');
  form.value.distancestart=this.filtersrtdistance;
  form.value.distance=this.filterenddistance;
  form.value.startprice=this.filtersrtprice;
  form.value.endprice=this.filterendprice;
  form.value.BHKK=form.value.BHK;
  let server = this.citylist.find(x => x.id === form.value.city);
  var bhkval='Any BHK'
  if(form.value.BHK!==''){
    form.value.BHK="'"+form.value.BHK+"'";
    bhkval=form.value.BHK;
  }
  this.showcitydata={
    cityname:server.value,
    bhk:bhkval,
  }
  form.value.amenityArry=this.filteramenitiesArry;
  
           this.filtrcity=form.value.city;
           this.filterbkhstring=form.value.BHK;
           this.formBHKK=form.value.BHK;
           this.getfilterData(form.value);

   }
}
clearContenlist(){
  this.contentlist=[];
}
isEmptyObject(obj) {
  return (obj && (Object.keys(obj).length === 0));
}
addfavrate(objArry,type) {

  if(Object.keys(this.userData).length == 0){
    this.needLogin();
    return false;
  }else{
    this._pg.addpgfavourite(this.userData.id,objArry.id).subscribe((data : any)=>{
      if(data.error==0){ 
     let locarry:any;
     if(type=="favrate"){
        objArry.pgId=objArry.id;
     }else{
      objArry.pgId=0;
      //console.log(objArry);
     }
      }
    });
  } 
 
}
needLogin(){
  this.commonservice.setLoginBox(true);        
} 
detailpg(pgId){
  let encodeUrl:any;
  //this.router.navigateByUrl('/pgdetail?cid='+btoa(pgId));
  //var encodeUrl="cid='+btoa(pgId)+'&lat='+btoa(this.lat)+'&lng='+btoa(this.lng)";
  encodeUrl="cid="+pgId+"&lat="+this.lat+"&lng="+this.lng+"&bhk="+this.showcitydata.bhk+"&add="+this.locationInput+"&city="+this.showcitydata.cityname;
  encodeUrl=encodeURIComponent(encodeUrl);
  window.open(this.global.websiteUrl+'pgdetail?searchparam='+btoa(encodeUrl)); 
}
getfilterData(formvalue){
 // console.log('real fun');
  //console.log(formvalue.fav);
  //console.log(this.lat);
  this.showfilterAvailBhk=true;
  // if(formvalue.fav!=undefined){
  //   console.log('not real con');
  //   formvalue.offset=0;
  //   formvalue.limit=this.limit;
  //   if(this.pageoffset>0 && this.pageoffset<20){
  //     formvalue.limit=this.pageoffset;
  //   }
    
  // }
  // else{
    //console.log('real con');
    formvalue.offset= this.contentlist.length?this.contentlist.length:0;
    this.pageoffset=this.contentlist.length?this.contentlist.length:0;
    formvalue.limit=this.limit;
  //}
  //console.log(formvalue.offset);
 // console.log(formvalue.limit);
  
          if(formvalue.BHKK!=''){
            this.showfilterAvailBhk=false;
          }
          if(formvalue.search==''){
            this.lat='';
            this.lng=''
            formvalue.lat='';
            formvalue.lng='';
          }
          this._pg.getfilterlist({0:formvalue}).subscribe((data : any)=>{

            if(data.error==0){
             // console.log('city select');
             // console.log(formvalue);
              if(formvalue.city!=undefined){
                this.showfilterContaint=true;
              this.showfiltercssfirst=false;
              this.showsearchcontaint=false;
                
              }
              
             // console.log('mmmmmmmmmmmmm');
             // console.log(data.count.length);
             // console.log(data.results.length);
              
              if(data.results.length>0){
                  for(var i in data.results){
                        if(data.results[i].images!=null){
                        data.results[i].pgimages = data.results[i].images.split(',');
                        }
                        else{
                          data.results[i].pgimages=["noimg.jpg"];
                        }
                  }
              //console.log('kklkllklkl');
                this.isPostLoad=false;
                //console.log(data.results);
                // if(formvalue.fav==undefined){
                  if(this.contentlist.length<data.count.length){
                    //console.log('push');
                Array.prototype.push.apply(this.contentlist,data.results);
                  }
                //this.contentlist=this.removeDuplicates(this.contentlist,'id');
                this.dataarryfavrt=this.contentlist;
                //console.log(this.contentlist);
                // }else{console.log('kklkllklkl'); this.contentlist=data.results;}
                //console.log(this.contentlist);

              }
            
              else{
                if(data.count.length<data.results.length){
                  //console.log('remaining');
                  this.isRemaningForum=false;
                }
                
                this.isPostLoad=false;
                this.noMoreResults = true;
              }
              if(data.count.length>0){
                this.totalcountdata=data.count.length;
                this.notfound=true;
                this.recordmsg=data.count.length+' record found';
              }
              else{
                this.notfound=false;
                this.recordmsg='Data not found.';
              }
           }else{
              if(data.message=="Failed to authenticate token."){
                this.router.navigate(['/admin']);
              }else{
              this.msg = data.message;
              this.isError = true;
              }
            }
        },
        (error : HttpErrorResponse)=>{
        this.isError = true;
        this.msg="internal server error!";
        });
}
removeDuplicates( arr, prop ) {
  var obj = {};
  for ( var i = 0, len = arr.length; i < len; i++ ){
    if(!obj[arr[i][prop]]) obj[arr[i][prop]] = arr[i];
  }
  var newArr = [];
  for ( var key in obj ) newArr.push(obj[key]);
  return newArr;
}
hidedropdwn(){
  this.dropdownOpen = false;
}

ownerVerification(verifyform){
  if(verifyform.status=="INVALID"){
    this.mobilevailidation=true;
    this.msgclass="danger";
    this.pgownerveifymsg="Please fill all the details";
   }else{
    this.mobilevailidation=false;
    verifyform.value.type='PG';
  //console.log(verifyform.value);
  //console.log(this.verifyOtpId);
  if(this.verifyOtpId){
    //console.log('id find');
    
    this._pg.verifyOTP(verifyform.value,this.verifyOtpId).subscribe((dataverify : any)=>{
      //console.log('MSG Responcettt');
      //console.log(dataverify);
      if(dataverify.error==0){ 
        this.verifyOtpId='';
        this.verifyStatus=false;
        this.mobilevailidation=true;
        this.msgclass="success";
        this.ownerarry={
          'studmobile':'',
          'otp':'',
        }
        this.pgownerveifymsg="Detail has been send on your mobile.";
      }
      else{
        this.mobilevailidation=true;
         this.msgclass="danger";
         this.pgownerveifymsg=dataverify.message;
        
      }
    });
  }
  else{
    this._pg.sendOTP(verifyform.value).subscribe((data : any)=>{
      //console.log('MSG Responce1234');
      //console.log(data);
      if(data.error==0){ 
        this.verifyOtpId=data.lastinserId;
        this.verifyStatus=true;
        
        
      }
    });

  }
 }
  
}
/*********GEO LOCATION**********/

ngOnChanges(): any {
  this.moduleinit = true;
  this.moduleInit();
}


//function called when click event happens in input box. (Binded with view)
searchinputClickCallback(event: any): any {
  
  event.target.select();
  this.searchinputCallback(event);
}
deselectlocationmap(event: any): any{
 
  this.dropdownOpen = false;
}

//function called when there is a change in input. (Binded with view)
searchinputCallback(event: any): any {
  
  let inputVal: any = this.locationInput;
  if ((event.keyCode === 40) || (event.keyCode === 38) || (event.keyCode === 13)) {
    this.navigateInList(event.keyCode);
    ///console.log(this.navigateInList(event.keyCode));
  } else if (inputVal) {
    
    this.getListQuery(inputVal);
    //console.log(this.getListQuery(inputVal));
  } else {
    //console.log('tttt');
    this.queryItems = [];
    if (this.userSelectedOption) {
      this.userQuerySubmit('false');
    }
    this.userSelectedOption = '';
    if (this.settings.showRecentSearch) {
      this.showRecentSearch();
    }else {
      this.dropdownOpen = false;
    }
  }
}

//function to execute when user hover over autocomplete list.(binded with view)
activeListNode(index: number): any {
  for (let i: number = 0; i < this.queryItems.length; i++) {
    if (index === i) {
      this.queryItems[i].active = true;
      this.selectedDataIndex = index;
    }else {
      this.queryItems[i].active = false;
    }
  }
}

//function to execute when user select the autocomplete list.(binded with view)
selectedListNode(index: number): any {
  this.dropdownOpen = false;
  if (this.recentDropdownOpen) {
    this.setRecentLocation(this.queryItems[index]);
  }else {
    this.getPlaceLocationInfo(this.queryItems[index]);
  }
}

//function to close the autocomplete list when clicked outside. (binded with view)
closeAutocomplete(event: any): any {
  if (!this._elmRef.nativeElement.contains(event.target)) {
    this.selectedDataIndex = -1;
    this.dropdownOpen = false;
  }
}

//function to manually trigger the callback to parent component when clicked search button.
userQuerySubmit(selectedOption?: any): any {
  //console.log('ffff');
  let _userOption: any = selectedOption === 'false' ? '' : this.userSelectedOption;
  if (_userOption) {
    this.componentCallback.emit({'response': true, 'data': this.userSelectedOption});
  }else {
    this.componentCallback.emit({'response': false, 'reason': 'No user input'});
  }
}

//function to get user current location from the device.
currentLocationSelected(): any {
  
  if (isPlatformBrowser(this.platformId)) {
    this.gettingCurrentLocationFlag = true;
    this.dropdownOpen = false;
    this._autoCompleteSearchService.getGeoCurrentLocation().then((result: any) => {
      if (!result) {
        this.gettingCurrentLocationFlag = false;
        this.componentCallback.emit({'response': false, 'reason': 'Failed to get geo location'});
      }else {
        this.getCurrentLocationInfo(result);
      }
    });
  }
}

//module initialization happens. function called by ngOninit and ngOnChange
private moduleInit(): any {
  this.settings = this.setUserSettings();
  //condition to check if Radius is set without location detail.
  if (this.settings.geoRadius) {
      if (this.settings.geoLocation.length !== 2) {
        this.isSettingsError = true;
        this.settingsErrorMsg = this.settingsErrorMsg +
        'Radius should be used with GeoLocation. Please use "geoLocation" key to set lat and lng. ';
      }
  }

  //condition to check if lat and lng is set and radious is not set then it will set to 20,000KM by default
  if ((this.settings.geoLocation.length === 2) && !this.settings.geoRadius) {
    this.settings.geoRadius = 20000000;
  }
  if (this.settings.showRecentSearch) {
    this.getRecentLocations();
  }
  if (!this.settings.useGoogleGeoApi) {
    if (!this.settings.geoPredictionServerUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Prediction custom server url is not defined. Please use "geoPredictionServerUrl" key to set. ';
    }
    if (!this.settings.geoLatLangServiceUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Latitude and longitude custom server url is not defined. Please use "geoLatLangServiceUrl" key to set. ';
    }
    if (!this.settings.geoLocDetailServerUrl) {
      this.isSettingsError = true;
      this.settingsErrorMsg = this.settingsErrorMsg +
      'Location detail custom server url is not defined. Please use "geoLocDetailServerUrl" key to set. ';
    }
  }
  this.locationInput = this.settings.inputString;
}

//function to process the search query when pressed enter.
private processSearchQuery(): any {
  if (this.queryItems.length) {
    if (this.selectedDataIndex > -1) {
      this.selectedListNode(this.selectedDataIndex);
    }else {
      this.selectedListNode(0);
    }
  }
}

//function to set user settings if it is available.
private setUserSettings(): Settings {
  let _tempObj: any = {};
  if (this.userSettings && typeof(this.userSettings) === 'object') {
    let keys: string[] = Object.keys(this.defaultSettings);
    for (let value of keys) {
      _tempObj[value] = (this.userSettings[value] !== undefined) ? this.userSettings[value] : this.defaultSettings[value];
    }
    return _tempObj;
  }else {
    return this.defaultSettings;
  }
}

//function to get the autocomplete list based on user input.
private getListQuery(value: string): any {

  this.recentDropdownOpen = false;
  if (this.settings.useGoogleGeoApi) {
    let _tempParams: any = {
      'query': value,
      'countryRestriction': this.settings.geoCountryRestriction,
      'geoTypes': this.settings.geoTypes
    };
   
    if (this.settings.geoLocation.length === 2) {
     
      _tempParams.geoLocation = this.settings.geoLocation;
      _tempParams.radius = this.settings.geoRadius;
    }
    this._autoCompleteSearchService.getGeoPrediction(_tempParams).then((result) => {
      this.updateListItem(result);
    });
  }else {
    this._autoCompleteSearchService.getPredictions(this.settings.geoPredictionServerUrl, value).then((result) => {
      result = this.extractServerList(this.settings.serverResponseListHierarchy, result);
      this.updateListItem(result);
    });
  }
}

//function to extratc custom data which is send by the server.
private extractServerList(arrayList: any, data: any): any {
  if (arrayList.length) {
    let _tempData: any = data;
    for (let key of arrayList) {
      _tempData = _tempData[key];
    }
    return _tempData;
  }else {
    return data;
  }
}

//function to update the predicted list.
private updateListItem(listData: any): any {
  this.queryItems = listData ? listData : [];
  this.dropdownOpen = true;
}

//function to show the recent search result.
private showRecentSearch(): any {
  this.recentDropdownOpen = true;
  this.dropdownOpen = true;
  this._autoCompleteSearchService.getRecentList(this.settings.recentStorageName).then((result: any) => {
    if (result) {
      this.queryItems = result;
    }else {
      this.queryItems = [];
    }
  });
}

//function to navigate through list when up and down keyboard key is pressed;
private navigateInList(keyCode: number): any {
  let arrayIndex: number = 0;
  //arrow down
  if (keyCode === 40) {
    if (this.selectedDataIndex >= 0) {
      arrayIndex = ((this.selectedDataIndex + 1) <= (this.queryItems.length - 1)) ? (this.selectedDataIndex + 1) : 0;
    }
    this.activeListNode(arrayIndex);
  }else if (keyCode === 38) {//arrow up
    if (this.selectedDataIndex >= 0) {
      arrayIndex = ((this.selectedDataIndex - 1) >= 0) ? (this.selectedDataIndex - 1) : (this.queryItems.length - 1);
    }else {
      arrayIndex = this.queryItems.length - 1;
    }
    this.activeListNode(arrayIndex);
  } else {
    this.processSearchQuery();
  }
}

//function to execute to get location detail based on latitude and longitude.
private getCurrentLocationInfo(latlng: any): any {
  
  if (this.settings.useGoogleGeoApi) {
    this._autoCompleteSearchService.getGeoLatLngDetail(latlng).then((result: any) => {
      if (result) {
       this.setRecentLocation(result);
      }
      this.gettingCurrentLocationFlag = false;
    });
  }else {
    this._autoCompleteSearchService.getLatLngDetail(this.settings.geoLatLangServiceUrl, latlng.lat, latlng.lng).then((result: any) => {
      if (result) {
        //console.log(result);
        result = this.extractServerList(this.settings.serverResponseatLangHierarchy, result);
        this.setRecentLocation(result);
      }
      this.gettingCurrentLocationFlag = false;
    });
  }
}

//function to retrive the location info based on goovle place id.
private getPlaceLocationInfo(selectedData: any): any {

  if (this.settings.useGoogleGeoApi) {
    this._autoCompleteSearchService.getGeoPlaceDetail(selectedData.place_id).then((data: any) => {
      if (data) {
       
        this.setRecentLocation(data);
      }
    });
  }else {
    this._autoCompleteSearchService.getPlaceDetails(this.settings.geoLocDetailServerUrl, selectedData.place_id).then((result: any) => {
      if (result) {
        result = this.extractServerList(this.settings.serverResponseDetailHierarchy, result);
        this.setRecentLocation(result);
      }
    });
  }
}

//function to store the selected user search in the localstorage.
private setRecentLocation(data: any): any {
  
  data = JSON.parse(JSON.stringify(data));

  data.description = data.description ? data.description : data.formatted_address;
  data.active = false;
  this.selectedDataIndex = -1;
  this.locationInput = data.description;
  this.lat=data.geometry.location.lat;
  this.latitude=data.geometry.location.lat;
  this.lng=data.geometry.location.lng;
  this.longitude=data.geometry.location.lng;
  if (this.settings.showRecentSearch) {
    this._autoCompleteSearchService.addRecentList(this.settings.recentStorageName, data, this.settings.noOfRecentSearchSave);
    this.getRecentLocations();
  }
  this.userSelectedOption = data;
  //below code will execute only when user press enter or select any option selection and it emit a callback to the parent component.
  if (!this.settings.resOnSearchButtonClickOnly) {
    this.componentCallback.emit({'response': true, 'data': data});
  }
}

//function to retrive the stored recent user search from the localstorage.
private getRecentLocations(): any {
  this._autoCompleteSearchService.getRecentList(this.settings.recentStorageName).then((data: any) => {
    this.recentSearchData = (data && data.length) ? data : [];
  });
}
/***************GEO LOCATION****************/
private setCurrentPosition() {
  if ("geolocation" in navigator) {
    navigator.geolocation.getCurrentPosition((position) => {
      this.latitude = position.coords.latitude;
      this.longitude = position.coords.longitude;
      this.zoom = 12;
    });
  }
}


}



// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/home/vpg/vpg.component.ts